import { CANADIAN_PROVINCES_MAPPING } from './constants';

/**
 * parses province from given serviceAddress
 * @param {String} serviceAddress - complete address
 * @returns {String} just the abbreviation like 'AB', 'BC' or empty string '' if error occurred.
 */
const parseProvince = serviceAddress => {
  let province = '';
  try {
    const addrSplit = serviceAddress.split(',');
    if (addrSplit.length > 4) {
      const provincePart = addrSplit[addrSplit.length - 2].trim();
      province = provincePart.split(' ')[0].trim();
    }
     else if (addrSplit.length === 4) {
      // e.g. Karachi Dr, Markham, ON L3S, Canada
      const provincePart = addrSplit[2].trim();
      province = provincePart.split(' ')[0].trim();
    } else if (addrSplit.length === 3) {
      // e.g. Peterborough, ON, Canada
      const provincePart = addrSplit[1].trim();
      province = provincePart.split(' ')[0].trim();
      if(province.length > 2) { // 'Alberta', 'Ontario'
        const { abbreviation } = CANADIAN_PROVINCES_MAPPING.find(
          obj => obj.name === province
        );
        province = abbreviation;        
      }
    } else if (addrSplit.length === 2) {
      // e.g. Ontario, Canada
      const provincePart = addrSplit[0].trim();
      const { abbreviation } = CANADIAN_PROVINCES_MAPPING.find(
        obj => obj.name === provincePart
      );
      province = abbreviation;
    }
  } catch (err) {
    province = '';
  }
  return province;
};

export { parseProvince };
